@if(visible | async) {
<ng-container>
  <button mat-fab color="tertiary" [@fadeInOut] (click)="utilsService.scrollToTop()" class="back-to-top"
    matTooltip="Torna su" aria-label="Back to top">
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
</ng-container>
}
